module.exports = __webpack_public_path__ + "static/media/mobile_menu_background.d0b57086.svg";